import React, {Component} from 'react';
import PropTypes from 'prop-types';

import DropdownList from '@stubhub/react-dropdown-list';

import GENRES from '../../helpers/genres';

import './index.scss';

class SubGenreDropDown extends Component {
  constructor(props) {
    super(props);
    const {genreModuleCategory, selected} = props;
    this.subcategories = GENRES[genreModuleCategory].map((category, index) => {
      category.key = index;

      return category;
    });
    this.category = selected || this.subcategories[0];
  }

  onSelection = (item) => {
    const {onSelection, genreModuleCategory} = this.props;
    this.category = item;
    onSelection(item, genreModuleCategory);
  };

  onSelectionDesktop = (category, index) => {
    if (category.ids === this.category.ids) {
      return null;
    }
    const {onSelection, genreModuleCategory} = this.props;
    this.category = category;
    const item = category;
    item.key = index;
    onSelection(item, genreModuleCategory);
  };

  renderSubgenreModule = () => {
    const {enableSubGenreModuleDesktop, enableSubGenreModuleMweb, useBackdrop, genreModuleCategory} = this.props;
    const currentCategory = this.category;
    if (enableSubGenreModuleMweb) {
      return (
        <DropdownList
          className="subgenre-dropdown"
          selectionTitle={this.category.name}
          selected={this.category}
          items={this.subcategories}
          onSelection={this.onSelection}
          useCheckMark
          inPillBar
          draggable
          useBackdrop={useBackdrop}
        />
      );
    } else if (enableSubGenreModuleDesktop) {
      const DOM_subcategories = GENRES[genreModuleCategory].map((category, index) => {
        const isActive = category.ids[0] === currentCategory.ids[0];

        return (
          <li
            className={`genre-module--subcategories--subcategory${(isActive && ' active') || ''}`}
            key={`genre-module--subcategory-${index}`}
            onClick={() => this.onSelectionDesktop(category, index)}
          >
            {category.name}
          </li>
        );
      });

      return <ul className="genre-module--subcategories-desktop">{DOM_subcategories}</ul>;
    }
  };

  render() {
    return <div className="subgenre-desktop-mweb">{this.renderSubgenreModule()}</div>;
  }
}

SubGenreDropDown.propTypes = {
  /**
   * Configuration to Render the Tab
   *
   */
  genreModuleCategory: PropTypes.string.isRequired,

  /**
   * Default selected value
   *
   */
  selected: PropTypes.object,

  /**
   * Function to exec when dropdown value changed
   */
  onSelection: PropTypes.func.isRequired,

  /**
   * Whether use backdrop on mWeb
   */
  useBackdrop: PropTypes.bool,
  // This will only be true if feature toggle is on and AB testing is v1
  enableSubGenreModuleMweb: PropTypes.bool,
  // This will only be true if feature toggle is on and AB teting is v1
  enableSubGenreModuleDesktop: PropTypes.bool,
};

SubGenreDropDown.defaultProps = {
  genreModuleCategory: 'sports',
};

export default SubGenreDropDown;
